/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type SelfRegistrationStartInput = {
    entityReference: string;
    cellphoneNumber: string;
    clientMutationId?: string | null;
};
export type SelfRegistrationStartMutationVariables = {
    input: SelfRegistrationStartInput;
};
export type SelfRegistrationStartMutationResponse = {
    readonly selfRegistrationStart: {
        readonly clientMutationId: string | null;
        readonly cellphoneNumber: string;
    } | null;
};
export type SelfRegistrationStartMutation = {
    readonly response: SelfRegistrationStartMutationResponse;
    readonly variables: SelfRegistrationStartMutationVariables;
};



/*
mutation SelfRegistrationStartMutation(
  $input: SelfRegistrationStartInput!
) {
  selfRegistrationStart(input: $input) {
    clientMutationId
    cellphoneNumber
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SelfRegistrationStartPayload",
    "kind": "LinkedField",
    "name": "selfRegistrationStart",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cellphoneNumber",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SelfRegistrationStartMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SelfRegistrationStartMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3f6e8667cfa0aa1caf290e48a19cfa09",
    "id": null,
    "metadata": {},
    "name": "SelfRegistrationStartMutation",
    "operationKind": "mutation",
    "text": "mutation SelfRegistrationStartMutation(\n  $input: SelfRegistrationStartInput!\n) {\n  selfRegistrationStart(input: $input) {\n    clientMutationId\n    cellphoneNumber\n  }\n}\n"
  }
};
})();
(node as any).hash = '2de581f2e55228526abee6a1a3d0e9f2';
export default node;
